import { render } from "./SVGEdit.vue?vue&type=template&id=5a22e9d4"
import script from "./SVGEdit.vue?vue&type=script&lang=js"
export * from "./SVGEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__